import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../state/AuthContext";

export function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-full flex items-center justify-center text-slate">Loading session…</div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
